export enum Concentration {
    WNL = 'WNL',
    FAIR = 'Fair',
    POOR = 'Poor'
}